import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";

import PinList from "../../components/PinList";

import { getTopicPins } from "@/services";
import styles from "./index.module.less";

export default function SearchTopicPinList({ query, empty }) {
  const pageRef = useRef(1);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);

  const { q, filterId } = query;

  const queryAction = useMemo(() => {
    pageRef.current = 1;
    setDataSource([]);
    setHasMore(true);

    return async () => {
      if (!q || !filterId) {
        return;
      }

      const per_page = 20;

      const result = await getTopicPins({
        filter_ids: filterId,
        sort: "all",
        position: "topics",
        text: q,
        per_page,
        page: pageRef.current,
      });

      const pins = result?.pins || [];

      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource((dataSource) => dataSource.concat(pins));
      setTotal(result?.query?.total || 0);
    };
  }, [q, filterId]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  return (
    <div className={styles.tab}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          {total > 0 && (
            <div className={styles.info}>
              找到 {total} 个与 <span>{q}</span> 相关的采集
            </div>
          )}

          <PinList
            dataSource={dataSource}
            hideUser={true}
            showBoardLink={false}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
